import { Brain } from '@/shared/types/brain';

/** Takes the already-looked-up brain to avoid a second lookup; falls back to a short id label. */
export const resolveBrainName = (brainId: string, brain?: Brain): string =>
  brain?.name || `AI Agent ${brainId.slice(0, 8)}…`;
